import { render } from "./NotificationsCatPopup.vue?vue&type=template&id=a5efafd6"
import script from "./NotificationsCatPopup.vue?vue&type=script&lang=js"
export * from "./NotificationsCatPopup.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/nahodka.xpage.dev/htdocs/public/local/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__